module.exports = __webpack_public_path__ + "img/katsina.a5072eed.png";